import { useMemo, useState } from "react";

export default function RothVsTraditional() {
  const [contribution, setContribution] = useState(6000);
  const [years, setYears] = useState(25);
  const [returnRate, setReturnRate] = useState(7);
  const [currentTax, setCurrentTax] = useState(22);
  const [retirementTax, setRetirementTax] = useState(20);

  const annual = Number(contribution) || 0;
  const rate = (Number(returnRate) || 0) / 100;
  const yearsNum = Number(years) || 0;
  const currentRate = (Number(currentTax) || 0) / 100;
  const retireRate = (Number(retirementTax) || 0) / 100;

  const results = useMemo(() => {
    const futureValue = rate === 0 ? annual * yearsNum : annual * (Math.pow(1 + rate, yearsNum) - 1) / rate;
    const rothNet = futureValue;
    const traditionalGross = futureValue;
    const traditionalNet = traditionalGross * (1 - retireRate);
    const rothCost = annual * (1 + currentRate);
    return { rothNet, traditionalNet, futureValue, rothCost };
  }, [annual, rate, yearsNum, currentRate, retireRate]);

  return (
    <main style={{ padding: "120px 0 80px" }}>
      <div className="container">
        <h1 style={{ fontFamily: "Fraunces, serif", fontSize: 40, marginBottom: 8 }}>Roth vs. Traditional IRA</h1>
        <p style={{ color: "var(--t2)", marginBottom: 20 }}>Compare retirement outcomes with tax-paid-now vs. tax-paid-later assumptions.</p>

        <div className="card-base" style={{ padding: 18, marginBottom: 18 }}>
          <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 12 }}>
            <label>
              <div className="font-mono" style={{ fontSize: 11, color: "var(--t3)", marginBottom: 6 }}>Annual contribution</div>
              <input className="input" type="number" value={contribution} onChange={(e) => setContribution(e.target.value)} />
            </label>
            <label>
              <div className="font-mono" style={{ fontSize: 11, color: "var(--t3)", marginBottom: 6 }}>Years until retirement</div>
              <input className="input" type="number" value={years} onChange={(e) => setYears(e.target.value)} />
            </label>
            <label>
              <div className="font-mono" style={{ fontSize: 11, color: "var(--t3)", marginBottom: 6 }}>Expected annual return (%)</div>
              <input className="input" type="number" value={returnRate} onChange={(e) => setReturnRate(e.target.value)} />
            </label>
            <label>
              <div className="font-mono" style={{ fontSize: 11, color: "var(--t3)", marginBottom: 6 }}>Current tax rate (%)</div>
              <input className="input" type="number" value={currentTax} onChange={(e) => setCurrentTax(e.target.value)} />
            </label>
            <label style={{ gridColumn: "1 / -1" }}>
              <div className="font-mono" style={{ fontSize: 11, color: "var(--t3)", marginBottom: 6 }}>Expected retirement tax rate (%)</div>
              <input className="input" type="number" value={retirementTax} onChange={(e) => setRetirementTax(e.target.value)} />
            </label>
          </div>
        </div>

        <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 12 }}>
          <div className="card-base" style={{ padding: 18 }}>
            <div className="font-mono" style={{ fontSize: 11, color: "var(--t3)", marginBottom: 8 }}>Traditional IRA net at withdrawal</div>
            <div style={{ fontFamily: "Fraunces, serif", fontSize: 24 }}>${results.traditionalNet.toFixed(0)}</div>
          </div>
          <div className="card-base" style={{ padding: 18, border: "2px solid var(--emerald)" }}>
            <div className="font-mono" style={{ fontSize: 11, color: "var(--t3)", marginBottom: 8 }}>Roth IRA net after taxes</div>
            <div style={{ fontFamily: "Fraunces, serif", fontSize: 24, color: "var(--emerald)" }}>${results.rothNet.toFixed(0)}</div>
          </div>
        </div>

        <div className="card-base" style={{ padding: 18, marginTop: 14 }}>
          <div style={{ fontWeight: 700 }}>{results.rothNet >= results.traditionalNet ? "Roth appears stronger under these assumptions." : "Traditional appears stronger under these assumptions."}</div>
          <div style={{ color: "var(--t2)", marginTop: 8 }}>
            Traditional withdraws ${results.futureValue.toFixed(0)} then pays taxes at {retirementTax}%.
          </div>
        </div>
      </div>
    </main>
  );
}
